import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";

@Component({
  selector: 'app-sales-general-credit-summary',
  templateUrl: './sales-general-credit-summary.component.html',
})
export class SalesGeneralCreditSummaryComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly utilService = inject(UtilService);
  private requestService = inject(RequestService);
  private customMessageService = inject(CustomMessageService);

  private readonly request_id = this.route.snapshot.queryParams['request_id'];
  readonly categoryCode = this.route.snapshot.params['category_code'];
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Finalizado'];
  request = this.requestService.request;

  data = signal<any>({});


  ngOnInit(): void {
    this.load();
  }

  load(){
    this.utilService.enablePageLoading();
    this.data.set(this.request);
    this.utilService.disablePageLoading();

  }

  frequencyText(): string {
    return this.utilService.getFrequencyDescription(this.data().quotes?.frecuency);
  }

}
